import TimeFieldBase from '../base/TimeField';
import createField from './createField';

const TimeField = createField(TimeFieldBase);

export default TimeField;
